import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import './LegalPage.css';

const CookiePolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />
      
      <div className="legal-page">
        <div className="legal-container">
          {/* Header Section */}
          <div className="legal-header">
            <Link to="/" className="back-button">
              <ArrowLeft size={20} />
              <span>Back to Home</span>
            </Link>
            
            <div className="legal-title-section">
              <h1 className="legal-main-title">Cookie Policy</h1>
              <p className="legal-subtitle">
                Learn about how we use cookies to enhance your browsing experience.
              </p>
              <div className="legal-last-updated">
                Last updated: July 2025
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="legal-content">
            <div className="legal-content-card">
              
              <div className="legal-intro">
                <p>
                  <strong>echoesoflunaria.com</strong> uses cookies to enhance your browsing experience and maintain login sessions.
                </p>
              </div>

              <div className="legal-section">
                <h2>We use only essential cookies to:</h2>
                <ul>
                  <li>Keep you signed in</li>
                  <li>Track vos balance and user activity securely</li>
                  <li>Improve platform performance</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Third-Party Tracking</h2>
                <ul>
                  <li>We do not use third-party tracking or advertising cookies.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Your Consent</h2>
                <ul>
                  <li>By continuing to use the site, you agree to our use of cookies.</li>
                </ul>
              </div>

              <div className="legal-section">
                <h2>Contact</h2>
                <p>For questions, contact:</p>
                <p className="contact-info">📧 echosoflunaria@gmail.com</p>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default CookiePolicy;